import React, {
  useState, Fragment, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import { Select } from 'antd';
import ExtraChargesActions from '@Actions/configurations/extraChargesAction';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
/**
 * ExtraChargeForm component
 *
 * @param file
 */
const { Option } = Select;
const ExtraChargesForm = ({
  callback, selectedChargeUpdate, updateChargeLoading, createChargeLoading, createCharge, updateCharge, entityType,
}) => {


  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedChargeName, setSelectedChargeName] = useState(null);
  const [sacCode, setSacCode] = useState(null);


  useEffect(() => {
    if (selectedChargeUpdate) {
      setSelectedChargeName(selectedChargeUpdate?.ledger_name);
      setSacCode(selectedChargeUpdate?.charge_sac_code);
    }
  }, [selectedChargeUpdate]);

  const CreateCharge = () => {
    setFormSubmitted(true);
    const payload = {
      ledger_name: selectedChargeName,
      entity_name: entityType == 'PURCHASE_ORDER' ? 'PURCHASE' : 'SALES',
      charge_sac_code: sacCode,
    };
    if (selectedChargeName) {
      createCharge(payload, () => {
        setSelectedChargeName(null);
        setFormSubmitted(false);
        callback();
      });
    }
  };
  const UpdateCharge = () => {
    setFormSubmitted(true);
    const payload = {
      ledger_name: selectedChargeName,
      ledger_id: selectedChargeUpdate?.ledger_id,
      charge_sac_code: sacCode,
    };
    if (selectedChargeName) {
      updateCharge(payload, () => {
        setSelectedChargeName(null);
        setFormSubmitted(false);
        callback();
      });
    }
  };



  return (
    <Fragment>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3FormInput
            type="text"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(event) => {
              setSelectedChargeName(event.target.value);
            }}
            value={selectedChargeName}
            label="Charge Name"
            maxlength="100"
            required
            disabled={updateChargeLoading || createChargeLoading || selectedChargeUpdate?.is_system_charge}
            loading={updateChargeLoading || createChargeLoading}
          />
          {formSubmitted && !selectedChargeName && <div className="formError">*Please Fill the Charge Name.</div>}
        </div>
        <div className="ant-col-md-24">
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(event) => {
              setSacCode(event.target.value);
            }}
            value={sacCode}
            label="SAC Code"
            maxlength="100"
            required
            disabled={updateChargeLoading || createChargeLoading}
            loading={updateChargeLoading || createChargeLoading}
          />
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text={selectedChargeUpdate ? 'Update Charge' : 'Add Charge'}
            onClick={() => (selectedChargeUpdate ? UpdateCharge() : CreateCharge())}
            isLoading={updateChargeLoading || createChargeLoading}
            disabled={updateChargeLoading || createChargeLoading}
            style={{
              width: '180px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, ExtraChargesReducers }) => ({
  user: UserReducers.user,
  createChargeLoading: ExtraChargesReducers.createChargeLoading,
  updateChargeLoading: ExtraChargesReducers.updateChargeLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createCharge: (payload, callback) => dispatch(ExtraChargesActions.createCharge(payload, callback)),
  updateCharge: (payload, callback) => dispatch(ExtraChargesActions.updateCharge(payload, callback)),
});



export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExtraChargesForm));
